import {makeAutoObservable, runInAction} from "mobx"
import {APIRoom, RoomTypes, ShadowPayload, SimpleMessage} from "../clients/shadow/interfaces";
import {GatewayEvent} from "../clients/shadow/GatewayEvent";
import {ShadowClient} from "../clients/shadow/shadowClient";
import {User, UserStore} from "./UserStore";

export class RoomStore {
    rooms: Room[] = []
    isLoading = true
    private joinedRoomId: string;

    constructor(private client: ShadowClient, public userStore: UserStore) {
        makeAutoObservable(this)
        this.userStore = userStore // Store that can resolve authors.
        this.client = client // Thing that can make server requests.
        this.client.on("gateway-event", (event: ShadowPayload) => this.handleGatewayEvent(event))
    }

    get joinedRoom() {
        return this.joinedRoomId ? this.get(this.joinedRoomId) : null;
    }

    // Fetches all Rooms from the server.
    loadRooms() {
        this.isLoading = true
        this.client.getRooms().then(rooms => {
            runInAction(() => {
                rooms.forEach(json => this.upsertRoom(json))
                this.isLoading = false
            })
        })
    }

    handleGatewayEvent(event: ShadowPayload) {
        switch (event.type) {
            case GatewayEvent.ROOM_CREATE:
            case GatewayEvent.ROOM_UPDATE: {
                this.upsertRoom(event.data.room)
                break;
            }
            case GatewayEvent.ROOM_DELETE: {
                this.removeRoom(event.data.id);
                break;
            }
            default:
                break;
        }
    }

    upsertRoom(apiRoom: APIRoom): Room {
        let room = this.rooms.find(room => room.id === apiRoom.id)
        if (!room) {
            room = new Room(apiRoom, this,)
            this.rooms.push(room)
        }
        room.updateFromJson(apiRoom);
        return room;
    }

    getOwnedRoom() {
        const user = this.client.getClientUser();
        return user && this.rooms.find(user.ownsRoom)
    }

    getSortedRooms() {
        const rooms = [];
        const ownedRoom = this.getOwnedRoom();

        if (ownedRoom) {
            rooms.push(ownedRoom);
            rooms.push(...this.rooms.filter(room => room.id !== ownedRoom.id))
        } else {
            rooms.push(...this.rooms);
        }

        return rooms;
    }


    removeRoom(roomId: number | string) {
        this.rooms.splice(this.rooms.findIndex(room => room.id === roomId), 1);
    }

    get(id: string): Room | undefined {
        return this.rooms.find(room => room.id === id)
    }
}

export class Room {
    id: string = null;
    name: string = null;
    owner_id: string = null;
    owner: User = null;
    store: RoomStore = null;
    banned: string[] = [];
    users: string[] = [];
    invited: string[] = [];
    type: RoomTypes;
    user_count: number;
    lastMessage?: SimpleMessage | null = null;
    muted: string[];
    invite_tokens: string[] = [];

    constructor(apiRoom: APIRoom, store: any) {
        makeAutoObservable(this)
        this.store = store;
        this.updateFromJson(apiRoom);
    }

    updateFromJson(json: any) {
        Object.assign(this, json)
        this.owner = this.store.userStore.get(json.owner_id);
    }

}
